import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {PortalUrlComponent} from './components/portal-url/portal-url.component';
import {HttpInterceptor} from "./services/http-interceptor.service";
import {EstimateComponent} from './components/estimate/estimate.component';
import {AddressFormatPipe} from './shared/pipes/address-format.pipe';
import {SignaturePadComponent} from './components/signature-pad/signature-pad.component';
import {CollapseModule} from 'ngx-bootstrap/collapse';
import {HomePageComponent} from './components/home-page/home-page.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AlertComponent} from './components/alert/alert.component';
import {ModalModule} from 'ngx-bootstrap/modal';
import {SpinnerComponent} from './components/spinner/spinner.component';
import {FormatNumberPipe} from './shared/pipes/format-number.pipe';
import {InvoiceComponent} from './components/invoice/invoice.component';
import {EstimateDisplayListPipe} from './shared/pipes/estimate-display-list.pipe';
import { SanitizePipe } from './shared/pipes/sanitize.pipe';
import { PopoverModule } from 'ngx-bootstrap/popover';
import {InputNumberModule} from 'primeng/inputnumber';
import { ProjectReportComponent } from './components/project-report/project-report.component';
import { CompanyDisplayNamePipe } from './shared/pipes/company-display-name.pipe';
import { DisplayCompanyAndUserNameEstInvPipe } from './display-company-and-user-name-est-inv-pipe.pipe';
import { FilterDiscountsPipe } from 'src/filter-discount.pipe';
import { JustiFiPaymentComponent } from './components/justifi-payment/justifi-payment.component';
import { LightboxComponent } from './photo-swipe/lightbox/lightbox.component';
import { PreventMultiApiCallsDirective } from './shared/directives/prevent-multiple-calls.directive';
import { MemoizedFnPipe } from './shared/pipes/memoized-fn.pipe';
import { LogEventDirective } from './shared/directives/log-event.directive';
import { SoftBreakPipe } from './shared/pipes/soft-break.pipe';
import { LicenseLabelPipe } from './shared/pipes/license-label.pipe';

@NgModule({
  declarations: [
    AppComponent,
    PortalUrlComponent,
    EstimateComponent,
    AddressFormatPipe,
    MemoizedFnPipe,
    SignaturePadComponent,
    HomePageComponent,
    AlertComponent,
    SpinnerComponent,
    FormatNumberPipe,
    InvoiceComponent,
    EstimateDisplayListPipe,
    SanitizePipe,
    ProjectReportComponent,
    CompanyDisplayNamePipe,
    FilterDiscountsPipe,
    JustiFiPaymentComponent,
    DisplayCompanyAndUserNameEstInvPipe,
    LightboxComponent,
    PreventMultiApiCallsDirective,
    LogEventDirective,
    SoftBreakPipe,
    LicenseLabelPipe
  ],
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    CollapseModule.forRoot(),
    ModalModule.forRoot(),
    PopoverModule,
    InputNumberModule
  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: HttpInterceptor,
    multi: true,
  }, EstimateDisplayListPipe],
  exports: [AddressFormatPipe, SpinnerComponent],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
}
